import React from "react";
import { MdClose } from "react-icons/md";
import { Actions } from "../../context/reducer";
import { Action, SnackbarType } from "../../decleration";
import { AnimatePresence, motion } from "framer-motion";

const SnackBar = ({
  open,
  message,
  type,
  dispatch,
  content,
  onClose,
  isCloseable = true,
}: SnackbarType & { dispatch: (action: Action) => void }) => {
  const handleClose = () => {
    onClose?.();
    dispatch({
      type: Actions.SNACKBAR,
      payload: {
        open: false,
        message: "",
        content: null,
        type: "",
      },
    });
  };

  const types = React.useMemo(() => {
    return {
      info: "bg-[#F0F7FF]",
      warning: "bg-[#FFF3E0]",
      danger: "bg-[#FFE5E6]",
      error: "bg-[#FFE5E6]",
    };
  }, []);

  const variants = {
    initial: { y: "-100%" },
    animate: {
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 15,
        mass: 1,
      },
    },
    exit: {
      y: "-100%",
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 30,
      },
    },
  };

  return (
    <>
      <AnimatePresence>
        {open && (
          <>
            <motion.div
              className={`${
                types[type as keyof typeof types]
              } fixed top-0 z-[9998] w-full`}
              variants={variants}
              initial="initial"
              animate="animate"
              exit="exit"
            >
              <div className="container flex h-16 w-full flex-row items-center">
                <div className="flex-1 truncate text-black">
                  {message || content}
                </div>
                {isCloseable && (
                  <button
                    onClick={handleClose}
                    className={`rounded-full p-2 bg-${type} bg-opacity-20 text-primary`}
                  >
                    <MdClose />
                  </button>
                )}
              </div>
            </motion.div>
            <div className="h-16 w-full"></div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default SnackBar;
